<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="$t('forms.inputs.vehicleType')">
          <form @submit.prevent>
            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="vehicleTypesParams.name"
                  value="vehicleTypesParams.name"
                 :label="$t('forms.inputs.vehicleType')"
                 disabled
                >
                </va-input>
              </div>
              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="vehicleTypesParams.weight_capacity"
                  value="vehicleTypesParams.weight_capacity"
                 :label="$t('forms.inputs.weightCapacity')"
                 disabled
                >
                </va-input>
              </div>
            </div>
            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="vehicleTypesParams.cubage_capacity"
                  value="vehicleTypesParams.cubage_capacity"
                 :label="$t('forms.inputs.cubageCapacity')"
                 disabled
                >
                </va-input>
              </div>
              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="vehicleTypesParams.volume_capacity"
                  value="vehicleTypesParams.volume_capacity"
                 :label="$t('forms.inputs.volumeCapacity')"
                 disabled
                >
                </va-input>
              </div>
            </div>

            <div class="row">
              <div class="flex md2 sm6 xs12">
                <va-button
                  medium
                  inline
                  color="#ff842b"
                  icon="fa fa-chevron-left"
                  class="ma-0"
                  :to="{ name: 'vehicle_types', params: { page: this.$route.params.page } }" 
                >
                  {{ $t('menu.back') }}
                </va-button>
              </div>
            </div>

          </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>

import VehicleTypesAPI from '@/services/VehicleTypesAPI'

export default {
  name: 'form-vehicle-types',
  data () {
    return {
      vehicleTypesParams: {
        vehicleTypeId: '',
        name: '',
        weight_capacity: '',
        cubage_capacity: '',
        volume_capacity: ''
      },
    }
  },
  mounted () {
    if (this.$route.params.id != undefined) {
      VehicleTypesAPI.getVehicleTypeById(this.$route.params.id).then(response => {
        this.vehicleTypesParams = response.data.vehicle_type
      })
    }
  },
}
</script>